let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bUjWo")).then(() => parcelRequire('4DMt9'));